import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * ProtectedRoute Component
 * Componente de guarda que protege rotas autenticadas
 * Redireciona para login se o usuário não estiver autenticado
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
// ============================================================================
// Component
// ============================================================================
/**
 * ProtectedRoute
 *
 * Componente de rota protegida que verifica autenticação do usuário.
 *
 * Comportamento:
 * - Se loading: Exibe spinner de carregamento
 * - Se não autenticado: Redireciona para /app/login com state da localização atual
 * - Se autenticado: Renderiza children normalmente
 *
 * @example
 * ```tsx
 * <ProtectedRoute>
 *   <Dashboard />
 * </ProtectedRoute>
 * ```
 */
export const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();
    // Loading state - exibe spinner enquanto verifica autenticação
    if (loading) {
        return (_jsx("div", { className: "min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1a1a1a] to-[#020202] transition-colors duration-300", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "animate-spin rounded-full h-12 w-12 border-4 border-white/15 border-t-icavi-500 mx-auto mb-4" }), _jsx("p", { className: "text-white text-lg", children: "Carregando..." })] }) }));
    }
    // Não autenticado - redireciona para login salvando a localização atual
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: "/app/login", state: { from: location }, replace: true });
    }
    // Autenticado - renderiza children
    return _jsx(_Fragment, { children: children });
};
export default ProtectedRoute;
